import { render, staticRenderFns } from "./BannerSetting.vue?vue&type=template&id=6706d41f&scoped=true"
import script from "./BannerSetting.vue?vue&type=script&lang=js"
export * from "./BannerSetting.vue?vue&type=script&lang=js"
import style0 from "./BannerSetting.vue?vue&type=style&index=0&id=6706d41f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6706d41f",
  null
  
)

export default component.exports